/* ================================================================
   rq-pay-badges.js

   Drives the "or 4 payments of $X with [badges]" row rendered by
   sections/rq-pay-badges.liquid.

   Two jobs:

   1. PLACEMENT. A section cannot be nested inside the product
      information section, so the row renders wherever the section
      sits in the template and this file moves it so it lands
      immediately after the price block. The row is display:none
      until it is placed, so it never flashes at the bottom of the
      page first.

   2. THE AMOUNT. Liquid prints the opening amount; this re-reads the
      rendered price whenever it changes (variant switch, currency
      switch) and divides again, preserving the currency symbol,
      thousands separator and any trailing code such as USD exactly
      as the theme wrote them. No currency format is assumed.

   Re-render safety: when the theme editor re-renders the section it
   builds a FRESH row inside the section wrapper while the one this
   file already moved is still sitting up by the price. The fresh one
   is the one without .is-placed, so that is the one we keep; any
   others are removed. That is what stops duplicate rows appearing
   every time a setting is changed in the editor.
   ================================================================ */
(function () {
  'use strict';

  if (window.__rqPayBadges) return;
  window.__rqPayBadges = true;

  function priceEl() {
    var info = document.querySelector('.product__info-container');
    return info ? info.querySelector('.price') : null;
  }

  /* The price the customer is actually charged right now. */
  function priceText(p) {
    if (!p) return null;
    var sel = p.classList.contains('price--on-sale')
      ? '.price__sale .price-item--sale'
      : '.price__regular .price-item--regular';
    var el = p.querySelector(sel) || p.querySelector('.price-item');
    return el ? el.textContent.trim() : null;
  }

  function update(row) {
    var amt = row.querySelector('[data-rq-amt]');
    if (!amt) return;

    var txt = priceText(priceEl());
    if (!txt) return;

    var m = txt.match(/^([^0-9]*)([0-9][0-9.,]*)(.*)$/);
    if (!m) return;

    var pre = m[1];
    var raw = m[2];
    var post = m[3];

    /* Whichever of . or , appears last is the decimal separator. */
    var dec = '.';
    var grp = ',';
    if (raw.lastIndexOf(',') > raw.lastIndexOf('.')) { dec = ','; grp = '.'; }

    var val = parseFloat(raw.split(grp).join('').split(dec).join('.'));
    if (isNaN(val)) return;

    var n = parseInt(row.getAttribute('data-rq-count'), 10) || 4;
    var per = (Math.round(val * 100 / n) / 100).toFixed(2).split('.');
    var whole = per[0].replace(/\B(?=(\d{3})+(?!\d))/g, grp);
    var out = pre + whole + dec + per[1] + post;

    /* Only write on a real change, otherwise the observer below sees
       its own edit and loops forever. */
    if (amt.textContent !== out) amt.textContent = out;
  }

  /* Keep exactly one row per section id: prefer a freshly rendered
     one (no .is-placed), else keep the last and drop the rest. */
  function pick(sid) {
    var all = document.querySelectorAll('.rq-payrow[data-rq-sid="' + sid + '"]');
    if (!all.length) return null;

    var keep = null;
    for (var i = 0; i < all.length; i++) {
      if (!all[i].classList.contains('is-placed')) { keep = all[i]; break; }
    }
    if (!keep) keep = all[all.length - 1];

    for (var j = 0; j < all.length; j++) {
      if (all[j] !== keep) all[j].parentNode.removeChild(all[j]);
    }
    return keep;
  }

  function sectionIds() {
    var ids = [];
    var rows = document.querySelectorAll('.rq-payrow[data-rq-sid]');
    for (var i = 0; i < rows.length; i++) {
      var id = rows[i].getAttribute('data-rq-sid');
      if (ids.indexOf(id) === -1) ids.push(id);
    }
    return ids;
  }

  /* Safe to call as often as you like: it only touches the DOM when
     the row is not already sitting where it belongs. */
  function place() {
    var ids = sectionIds();

    for (var i = 0; i < ids.length; i++) {
      var row = pick(ids[i]);
      if (!row) continue;

      var p = priceEl();
      if (p) {
        var host = p.closest('.product__info-container > *') || p;
        if (host.nextElementSibling !== row) {
          host.insertAdjacentElement('afterend', row);
        }
      }

      row.classList.add('is-placed');
      update(row);
    }

    watch();
  }

  var queued = false;
  function schedule() {
    if (queued) return;
    queued = true;
    setTimeout(function () { queued = false; place(); }, 60);
  }

  function watch() {
    var info = document.querySelector('.product__info-container');
    if (!info || info.__rqPayWatched) return;
    info.__rqPayWatched = true;
    new MutationObserver(schedule).observe(info, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', place);
  } else {
    place();
  }

  /* Theme editor re-renders a section without reloading the page. */
  document.addEventListener('shopify:section:load', schedule);
  document.addEventListener('shopify:section:unload', schedule);
})();
